import { CustomVar, Liquidation } from 'src/services/reservation/pricing/pricingDTO'

export const getCustomVarsFromLiquidationRule = (liquidation: Liquidation): CustomVar[] | any[] | null => {
  if (
    typeof liquidation === 'object' &&
    Object.keys(liquidation)?.length > 0 &&
    'rules' in liquidation &&
    'customVars' in liquidation.rules
  ) {
    return liquidation.rules.customVars
  }
  return null
}
